import { InventoryCondition, LanguageInfo } from './inventory';

export const SHIPPING_METHOD = {
  ARRANGED: 'arranged',
  LOCAL_STORE: 'local_store',
  REGISTERED_MAIL: 'registered_mail',
  CORREIOS_PAC: 'correios_pac',
  CORREIOS_SEDEX: 'correios_sedex',
} as const;

export type ShippingMethod =
  (typeof SHIPPING_METHOD)[keyof typeof SHIPPING_METHOD];

export interface CartItem {
  id: string;
  offerId: string;
  cardId: string;
  cardSlug: string;
  cardGameCode: string;
  cardName: string;
  imageUrl?: string;
  printingCode: string;
  collectionName: string;
  rarityName: string;
  languageCode: string;
  languageName: string;
  condition: InventoryCondition;
  edition: import('./inventory').InventoryEdition | null;
  unitPrice: number;
  originalUnitPrice?: number;
  promotionEndsAt?: string;
  quantity: number;
  availableQuantity: number;
  store: {
    id: string;
    name: string;
    slug: string;
    buyoutLimit?: number;
    shippingMethods: import('./store').StoreShippingMethod[];
  };
}

export interface CartRecord {
  id: string;
  quantity: number;
  offer: {
    id: string;
    card: {
      id: string;
      slug: string;
      gameCode: string;
      namePt?: string;
      nameEn: string;
    };
    imageUrl?: string;
    printing: {
      code: string;
      collectionName: string;
      rarityName: string;
    };
    language: LanguageInfo;
    condition: InventoryCondition;
    edition: import('./inventory').InventoryEdition | null;
    unitPrice: string;
    originalUnitPrice?: string;
    promotionEndsAt?: string;
    availableQuantity: number;
    store: CartItem['store'];
  };
}

export interface CartItemInput {
  inventoryItemId: string;
  quantity: number;
}

export const CART_ERROR_CODE = {
  OFFER_UNAVAILABLE: 'cart-offer-unavailable',
  OFFER_LIMIT_REACHED: 'cart-offer-limit-reached',
  STORE_PURCHASE_LIMIT_REACHED: 'cart-store-purchase-limit-reached',
} as const;

export type CartBatchRejectionReason =
  | 'different_store'
  | 'offer_unavailable'
  | 'offer_limit_reached'
  | 'out_of_stock'
  | 'own_offer';

export interface CartBatchResult {
  accepted: CartItemInput[];
  rejected: Array<CartItemInput & { reason: CartBatchRejectionReason }>;
  items: CartRecord[];
}

export interface CartProductItem {
  id: string;
  quantity: number;
  offer: import('./product').ProductOffer;
  store: CartItem['store'];
}

export interface CartGroup {
  products?: CartProductItem[];
  store: CartItem['store'];
  items: CartItem[];
  quantity: number;
  subtotal: number;
}
